import React from 'react';
import { ButtonProps } from '../../../types';
import './Button.css';

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  children,
  onClick,
  href,
  disabled = false,
  loading = false,
  className = '',
  type = 'button',
  target,
  rel,
  style,
  ...props
}) => {
  const baseClasses = [
    'btn',
    `btn--${variant}`,
    `btn--${size}`,
    loading && 'btn--loading',
    className
  ].filter(Boolean).join(' ');

  // If href is provided, render as anchor tag
  if (href) {
    return (
      <a
        href={href}
        className={baseClasses}
        target={target}
        rel={target === '_blank' ? 'noopener noreferrer' : rel}
        style={style}
        {...props}
      >
        {loading && <span className="spinner" />}
        {children}
      </a>
    );
  }

  // Otherwise render as button
  return (
    <button
      type={type}
      className={baseClasses}
      onClick={onClick}
      disabled={disabled || loading}
      style={style}
      {...props}
    >
      {loading && <span className="spinner" />}
      {children}
    </button>
  );
};

export default Button;
